import { AuditResult } from "src/store/auditSlice";

// Core audit data types
export type IncidentField = {
  fieldName: string;
  auditResult: AuditResult;
  llmAnswer: string;
  austinAnswer: string;
  confirmedAnswer: string;
};

export type Incident = {
  incidentId: string;
  caseId: string;
  timestamp: string;
  dateReported: string;
  reviewer: string;
  auditWorkflowId: string;
  siteType: string;
  site: string;
  fields: IncidentField[];
  dqoCount: number;
  aiDefectCount: number;
  aiSource: string;
  obr_bu: string;
  obr_org: string;
  obr_scope: string;
};

export type AuditDataItem = {
  incidentId: string;
  caseId: string;
  timestamp: string;
  dateReported: string;
  reviewer: string;
  fieldName: string;
  auditResult: AuditResult;
  llmAnswer: string;
  austinAnswer: string;
  confirmedAnswer: string;
};

// Filter types
export enum FilterCondition {
  EQUALS = "Equals",
  IN = "In",
  BETWEEN = "Between",
}

export interface DataFilter {
  attributeName: string;
  attributeValues: string[];
  condition: FilterCondition;
}

// Extended type for audit data with Austin incident fields
export type AuditDataWithIncident = AuditDataItem & {
  org?: string;
  suborg?: string;
  site_type?: string;
  site?: string;
  case_number?: string;
  date_reported?: string;
  non_work_related?: boolean;
  obr_bu: string;
  obr_org: string;
  obr_scope: string;
};

// Metrics types (consolidated from metricsTypes.ts)
export enum MetricsPeriod {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  YEARLY = "yearly",
}

export interface FieldMetrics {
  field_name: string;
  total_count: number;
  dqo_count: number;
  dqo_rate: number;
  ai_defect_count: number;
  ai_defect_rate: number;
  neither_correct_count: number;
  neither_correct_rate: number;
  override_count: number;
  override_rate: number;
}

export interface OverallMetrics {
  total_incidents: number;
  total_audits: number;
  incidents_with_dqo: number;
  incidents_with_dqo_rate: number;
  total_dqo_count: number;
  total_dqo_rate: number;
  total_ai_defect_count: number;
  total_ai_defect_rate: number;
  total_neither_correct_count: number;
  total_neither_correct_rate: number;
  total_override_count: number;
  total_override_rate: number;
}

export interface MetricsResponse {
  period: MetricsPeriod;
  start_date: string;
  end_date: string;
  overall_metrics: OverallMetrics;
  field_metrics: FieldMetrics[];
}

export interface MetricsRequest {
  period: MetricsPeriod;
  start_date?: string;
  end_date?: string;
}
